import { useQuery } from '@tanstack/react-query';
import {
  type GetOrganisationsBoardsQueueRequestType,
  getOrganisationsBoardsQueue,
} from '../../api';
import { queryKey } from './query-key';

export const useGetOrganisationsBoardsQueue = (
  params: Partial<GetOrganisationsBoardsQueueRequestType>,
) =>
  useQuery({
    queryKey: queryKey.organisationBoardsQueue(
      params.organisationId!,
      params.boardId!,
    ),
    queryFn: () =>
      getOrganisationsBoardsQueue({
        organisationId: params.organisationId!,
        boardId: params.boardId!,
      }),
    enabled: !!params.organisationId && !!params.boardId,
  });
